import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const SpendingTrendChart = ({ monthlyData }) => {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Monthly Spending Trend'
      }
    }
  };

  const data = {
    labels: monthlyData.map(d => d.month),
    datasets: [{
      label: 'Total Spending',
      data: monthlyData.map(d => d.amount),
      borderColor: 'rgb(75, 192, 192)',
      tension: 0.1
    }]
  };

  return (
    <div className="bg-white rounded-lg p-4 shadow-sm">
      <Line options={options} data={data} />
    </div>
  );
}; 